(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.types = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.HandleLinks = _exports.DisplayPosition = _exports.DisplayOptions = _exports.CloseButtonPosition = void 0;
  /* eslint-disable no-use-before-define */
  var CloseButtonPosition = _exports.CloseButtonPosition = /*#__PURE__*/function (CloseButtonPosition) {
    CloseButtonPosition["TopLeft"] = "top-left";
    CloseButtonPosition["TopRight"] = "top-right";
    return CloseButtonPosition;
  }({});
  var HandleLinks = _exports.HandleLinks = /*#__PURE__*/function (HandleLinks) {
    HandleLinks["OpenAllNewTab"] = "open-all-new-tab";
    HandleLinks["OpenAllSameTab"] = "open-all-same-tab";
    HandleLinks["ExternalNewTab"] = "external-new-tab";
    return HandleLinks;
  }({});
  var DisplayOptions = _exports.DisplayOptions = /*#__PURE__*/function (DisplayOptions) {
    DisplayOptions["Immediate"] = "immediate";
    DisplayOptions["Deferred"] = "deferred";
    return DisplayOptions;
  }({});
  var DisplayPosition = _exports.DisplayPosition = /*#__PURE__*/function (DisplayPosition) {
    DisplayPosition["Center"] = "Center";
    DisplayPosition["TopRight"] = "TopRight";
    DisplayPosition["BottomRight"] = "BottomRight";
    DisplayPosition["Full"] = "Full";
    return DisplayPosition;
  }({});
});